import React, { useEffect, useState } from 'react'
import { PaymentMethodSelection } from './PaymentMethodSelection'

interface PaymentStepProps {
  onNextStep?: () => void
  onPreviousStep?: () => void
  onPaymentMethodSelect?: (method: string) => void
}

export const PaymentStep: React.FC<PaymentStepProps> = ({ onNextStep, onPreviousStep, onPaymentMethodSelect }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>('credit')

  useEffect(() => {
    onPaymentMethodSelect?.('credit')
  }, [])

  const handlePaymentMethodSelect = (method: string) => {
    setSelectedPaymentMethod(method)
    onPaymentMethodSelect?.(method)
  }

  const handleGoToFinalization = () => {
    if (selectedPaymentMethod) {
      onNextStep?.()
    }
  }

  return (
    <div className="space-y-6">
      <PaymentMethodSelection selectedMethod={selectedPaymentMethod} onSelect={handlePaymentMethodSelect} />
    </div>
  )
}
